export { PropertiesTable } from './PropertiesTable'
